import { render } from "./BatteryView.vue?vue&type=template&id=0b529cd1&scoped=true"
import script from "./BatteryView.vue?vue&type=script&lang=js"
export * from "./BatteryView.vue?vue&type=script&lang=js"

import "./BatteryView.vue?vue&type=style&index=0&id=0b529cd1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b529cd1"]])

export default __exports__